import { ItemOrQuantityIssueTypeInternational } from '../../../../enums';

export interface IQuantitySubtypeInt {
    issueType: ItemOrQuantityIssueTypeInternational;
    canIdentifyCartonId?: boolean;
    cartonId?: string;
    lotsDeclinedWithin24Hours?: boolean;
    unorderedItemQuantity?: number;
    unorderedItemSmn?: string;
}
